import { ReactNode } from 'react';

import { css } from '@emotion/css';

import { styled } from '../../theme';
import HorizontalButtonGroup from '../HorizontalButtonGroup';

const stripClass = css({ '&& > button': { overflow: 'hidden' } });

const StyledHorizontalButtonGroup = styled(HorizontalButtonGroup, {
    shouldForwardProp: (prop) => prop !== 'isSplitMode',
})<{ isSplitMode: boolean }>(({ theme, isSplitMode }) => ({
    marginBottom: 0,
    maxWidth: isSplitMode ? 'none' : 560,
    width: '100%',
    [theme.media.laptop]: {
        width: isSplitMode ? '100%' : '50%',
    },
    '> div': {
        width: '100%',
    },
    '> div > div': {
        width: '100%',
    },
}));

export type QueryModeSelectorProps<T extends string> = {
    isSplitMode: boolean;
    value: T;
    options: readonly T[];
    mapValueToLabel: (mode: T, isSelected: boolean) => ReactNode;
    onChange: (value: T) => void;
    ariaLabel?: string;
};

const QueryModeSelector = <T extends string>({
    isSplitMode,
    value,
    options,
    mapValueToLabel,
    onChange,
    ariaLabel,
}: QueryModeSelectorProps<T>) => (
    <StyledHorizontalButtonGroup
        isSplitMode={isSplitMode}
        value={value}
        options={[...options]}
        mapValueToLabel={(mode) => mapValueToLabel(mode, value === mode)}
        onSelect={onChange}
        stripClassName={stripClass}
        height={32}
        ariaLabel={ariaLabel}
    />
);

export default QueryModeSelector;
